import "../../Today/TodayPanels/BotRisk/BotRisk.scss";
//C:\Users\alex.hurst\Documents\GitHub\veracityapp\veracityapp\src\components\Today\TodayPanels\BotRisk\BotRisk.scss"
//react components
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
//libraries
import moment from "moment";
import { ResponsiveLine } from '@nivo/line';
//shared components
import { riskLevels, colors, classificationColors, botClassificationName } from "components/AFP/Constants";
const OverallThreatLevel = ({ websiteRiskData, finishedSessionsData }) => {
    //states

    function getTickSize() {
        const values = Object.keys(websiteRiskData?.item ?? []).length ?? 0;
        if (values > 20) {
            return 15
        } else {
            return values
        }
    };
    const tickValues = getTickSize();

    const formatData = () => {
        try {
            const result = [];
            for (let dates in websiteRiskData?.item) {
                result.push(
                    {
                        x: dates,
                        y: websiteRiskData.item[dates]?.websiteRiskLevel ?? 0,
                        riskLevel: riskLevels[websiteRiskData.item[dates]?.websiteRiskLevel] ?? "Low",
                        color: colors[websiteRiskData.item[dates]?.websiteRiskLevel] ?? "grey"
                    }
                )
            };
            if (result.length > 8) result.pop()
            const formattedData = [{ id: "Risk Level", data: result }];
            return formattedData
        } catch (error) {
            console.log("Format data ERROR", error)
        }
    };
    let formattedData = formatData();



    const ToolTip = ({ data }) => {

        return (
            <div className="toolTipContent">
                <div style={{ fontWeight: "bolder" }} > {moment(data.slice.points[0].data.xFormatted).format("Do MMM")}</div>
                <div>Risk Level: <span style={{ color: data.slice.points[0].data.color, fontWeight: "bold" }}>{data.slice.points[0].data.riskLevel}</span></div>
            </div>
        )
    };

    const getRiskLevelName = (level) => riskLevels[level] || '';

    function getRangeName() {
        switch (finishedSessionsData.timeRange) {
            case "Prev 7 Days":
                return "in the last 7 days"
            case "Prev 14 Days":
                return "in the last 14 days"
            case "Prev 28 Days":
                return "in the last 28 days"
            case "this month":
                return "in the current month"
            case "Last Month":
                return "in the last month"
            default:
                return "in the selected time frame"
        }
    }
    const rangeName = getRangeName();

    const getRiskStatusValues = () => {
        let riskIncrease;
        if (!formattedData) return null;;
        const riskStatus = formattedData[0]?.data[formattedData[0]?.data.length - 1]?.riskLevel;
        const backgroundColor = formattedData[0]?.data[formattedData[0]?.data.length - 1]?.color;

        if (formattedData[0]?.data[0]?.y == formattedData[0]?.data[formattedData[0]?.data.length - 1]?.y) {
            riskIncrease = 0
        } else if (formattedData[0]?.data[0]?.y < formattedData[0]?.data[formattedData[0]?.data.length - 1]?.y) {
            riskIncrease = true
        } else {
            riskIncrease = false
        }

        return { riskStatus, backgroundColor, riskIncrease }
    };
    const riskStatusValues = getRiskStatusValues();

    const RiskMeasurementLinegraph = useMemo(() => {
        console.log("formattedData", formattedData)
        return (
            <ResponsiveLine
                data={formattedData}
                margin={{ top: 25, right: 40, bottom: 120, left: 65 }}
                xScale={{
                    format: '%Y-%m-%d',
                    precision: 'hour',
                    type: 'time',
                    useUTC: false
                }}
                yScale={{
                    type: 'linear',
                    min: '0',
                    max: '4',
                    stacked: true,
                    reverse: false
                }}
                enablePoints={false}
                yFormat=" >-.2f"
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    legendOffset: -12,
                    tickSize: tickValues,
                    tickValues: "every 1 day",
                    format: (value) => {
                        return moment(value).format('Do MMM')
                    },
                    tickRotation: "45"
                }}
                enableSlices="x"
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legendOffset: -40,
                    truncateTickAt: 0,
                    format: value => getRiskLevelName(value)
                }}
                sliceTooltip={(e) => <ToolTip data={e} />}
                colors={({ id, data }) => colors[data[data.length - 1].y]}
                pointSize={10}
                pointColor={{ theme: 'background' }}
                pointBorderWidth={2}
                pointBorderColor={{ from: 'serieColor' }}
                pointLabel="data.yFormatted"
                pointLabelYOffset={-12}
                enableTouchCrosshair={true}
                useMesh={true}
            />
        )
    }, [websiteRiskData, formattedData]);

    return (
        <div>
            <div className="risk-measurement-container">
                <div className="graph-header" >
                    <div className="graph-heading">Average Threat Level</div>
                </div>
                {
                    <>
                        <div className="risk-status">
                            <span style={{ background: riskStatusValues.backgroundColor }}>
                                {riskStatusValues?.riskStatus}
                            </span>
                            <span style={{ color: riskStatusValues.backgroundColor }}>
                                {riskStatusValues?.riskIncrease === 0 ? "Threat has not changed" : riskStatusValues?.riskIncrease ? "↑ Increased" : "↓ Decreased"} {rangeName ?? "in the last 7 days"}
                            </span>
                        </div>
                        <div className="reporting-graph-size-box" style={{ height: '500px', width: '100%' }} >
                            {RiskMeasurementLinegraph}
                        </div>
                    </>
                }

            </div>
        </div>
    );
};

export default OverallThreatLevel;